import type { AuthenticationV1Account, EnumsV1Permission } from '@sdk/Api'
import { account } from '@store/account'
import { get } from 'svelte/store'

export function isAccountAllowed(
	permission: EnumsV1Permission,
	$account: AuthenticationV1Account = null,
) {
	const userAccount = $account || get(account)
	return userAccount?.role.permissions.includes(permission) || false
}

export function hasAccountOwnSources(account: AuthenticationV1Account): boolean {
	return Boolean(account.hasOwnSources)
}

export function hasSomePermission(
	permissions: EnumsV1Permission[],
	account: AuthenticationV1Account,
): boolean {
	for (const permission of permissions) {
		if (account.role.permissions.includes(permission)) {
			return true
		}
	}

	return false
}
